'use client';

import { forwardRef } from 'react';
import { Title as MantineTitle } from '@mantine/core';
import type { TitleProps as MantineTitleProps } from '@mantine/core';

import type { LockedProps } from '../types';

export type TitleProps = Omit<MantineTitleProps, LockedProps>;

/**
 * ### Title
 *
 * @description
 * Mantine's Title minus per-call-site style overrides (see {@link LockedProps}).
 * Set the heading level with `order` (defaults to 1).
 *
 * @example
 * ```tsx
 * <Title>Page Title</Title>
 * <Title order={3}>Subsection Title</Title>
 * ```
 *
 * @param props - {@link TitleProps}
 * @returns React component
 */
const Title = forwardRef<HTMLHeadingElement, TitleProps>((props, ref) => (
  <MantineTitle ref={ref} {...props} />
));
Title.displayName = 'Title';

export default Title;
